import React from 'react';
import { Button, FormField, Text } from '@wix/design-system';
import { Reviews } from '@wix/wix-ui-icons-common';
import { REVIEW_LINK } from '../utils/shared/constants';
import { useSettingsContext } from '../context/SettingsContext';

export default function AppReviewRequest() {
    const { settings } = useSettingsContext();

    if (!settings?.placeId) {
        return null;
    }

    return (
        <>
            <hr className='mt-2' />
            <div className='section'>
                <FormField label="App review">
                    <p><Text weight='thin'>Help us grow by leaving a review on Wix App Market</Text></p>
                    <div>
                        <a href={REVIEW_LINK} target='_blank' rel='noreferrer'>
                            <Button prefixIcon={<Reviews />} >Leave a Review</Button>
                        </a>
                    </div>
                </FormField>
            </div>
        </>
    );
}
